import { getData } from "@/utils/fetch";
import debounce from "debounce-promise";
import { defineStore } from "pinia";

let debouncedFetch = debounce(getData, 500);

export const useSceneStore = defineStore({
  id: "scene",
  state: () => ({
    scenes: {},
    features: {},
    featurebyid: {},
    scenebyfeatureid: {},
    bykodepetak: {},
    month: null,
    dates: [],
    currentMonth: "",
    minPage: null,
    maxPage: null,
    page: 1,
    tgl: [],
  }),
  getters: {
    getScenes(state) {
      return state.scenebyfeatureid.data;
    },
  },
  actions: {
    async getAllSgnksofeatures(params) {
      this.features = { loading: true };
      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("sgn_kso_features", dataparams);
        this.features = { ...result.data };
      } catch (error) {
        console.log(error);
        this.features = { error };
      }
    },

    async getByFeatureid(featureid) {
      try {
        const result = await debouncedFetch("sgn_kso_features/" + featureid);
        this.featurebyid = { ...result.data };
      } catch (error) {
        console.log(error);
        this.featurebyid = { error };
      }
    },

    async getAllScenes(params) {
      this.scenes = { loading: true };
      const dataparams = {
        limit: params?.limit || 50,
        offset: params?.offset || 0,
        q: params?.q,
      };

      try {
        const result = await debouncedFetch("scene", dataparams);
        this.scenes = { ...result.data };
      } catch (error) {
        console.log(error);
        this.scenes = { error };
      }
    },

    async getSceneFeatureid(featureid) {
      this.scenebyfeatureid = { loading: true };
      try {
        const result = await debouncedFetch("scene/" + featureid);
        this.scenebyfeatureid = { ...result.data };
      } catch (error) {
        console.log(error);
        this.scenebyfeatureid = { error };
      }
    },

    async getSceneKodePetak(kodepetak) {
      this.bykodepetak = { loading: true };
      try {
        const result = await debouncedFetch("scene/bykodepetak/" + kodepetak);
        this.bykodepetak = { ...result.data };
      } catch (error) {
        console.log(error);
        this.bykodepetak = { error };
      }
    },
  },
});
